import { render, staticRenderFns } from "./CampaignsGrid.vue?vue&type=template&id=07123a75&scoped=true"
import script from "./CampaignsGrid.vue?vue&type=script&lang=js"
export * from "./CampaignsGrid.vue?vue&type=script&lang=js"
import style0 from "./CampaignsGrid.vue?vue&type=style&index=0&id=07123a75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07123a75",
  null
  
)

export default component.exports